export default __webpack_public_path__ + "static/media/gallery07.1fc75e86.jpg";